import { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { useSelector } from "react-redux";
import { API_URL, handleError, isManagerOver, downloadFile, isAccountant } from "src/Common/function";
import Button from "src/Components/Button";
import DownloadButton from "src/Components/DownloadButton";
import POService from "src/Services/API/po.service";
import UserService from "src/Services/API/user.service";
import POFitlerView from "src/Components/filter/POFilterView";
import BranchBar from "src/Components/branchbar/BranchBar";
import PoTable, { PO_SCROLL_STORAGE_KEY } from "./Components/PoTable";

function PO() {
  const user = UserService.getCurrentUser();
  // const keyword = useSelector((state) => state.Keyword.keyword);
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [orderArray, setOrderArray] = useState([]);
  const [loadMoreButtonShown, setLoadMoreButtonShown] = useState(false);
  //filter & sort
  const [filterOpen, setFilterOpen] = useState(false);
  const [sort, setSort] = useState(null);
  // True while a scroll restore is fetching the previously loaded rows.
  const [restoring, setRestoring] = useState(false);

  const [isDownloading, setIsDownloading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const criteria = searchParams.get("criteria");
  const [branch, setBranch] = useState(() => {
    const param = searchParams.get("branch");
    return param === null ? -1 : Number(param);
  });

  const keyword = searchParams.get("keyword") || "";

  // Pending scroll restoration coming back from the PO detail page.
  // Holds the saved PO id while pages are auto-loaded until it appears.
  const restoreRef = useRef(null);
  // Bumped on every fresh fetch cycle; responses from an older cycle (e.g.
  // the double fetch caused by branch initialization) are dropped so they
  // cannot overwrite the list or cancel a pending restore.
  const fetchGenRef = useRef(0);

  useEffect(() => {
    const param = searchParams.get("branch");
    setBranch(param === null ? -1 : Number(param));
  }, [searchParams]);

  useEffect(() => {
    fetchGenRef.current += 1;
    const gen = fetchGenRef.current;
    const saved = sessionStorage.getItem(PO_SCROLL_STORAGE_KEY);
    let pending = null;
    try {
      pending = saved ? JSON.parse(saved) : null;
      if (pending && pending.search !== undefined && pending.search !== location.search) {
        // Saved from a different filter/branch context — not restorable here.
        sessionStorage.removeItem(PO_SCROLL_STORAGE_KEY);
        pending = null;
      }
    } catch {
      pending = null;
      sessionStorage.removeItem(PO_SCROLL_STORAGE_KEY);
    }
    restoreRef.current = pending;
    setRestoring(!!pending);
    // A pending restore fetches every previously loaded row in one request.
    const limit = pending?.loadedCount > 0 ? pending.loadedCount : undefined;
    getAllPurchaseOrder([], { limit }, gen);

    if (criteria) {
      setFilterOpen(true);
    } else {
      setFilterOpen(false);
    }
    console.log("🚀 ~ PO ~ branch:", branch);
  }, [keyword, criteria, sort, branch]);

  const getAllPurchaseOrder = (previousOrderArray, { limit } = {}, gen = fetchGenRef.current) => {
    // Offset-based continuation: rows deleted from the list can't shift page
    // boundaries the way pageNumber-based pagination could.
    const offset = previousOrderArray.length;
    POService.getPurchaseOrder(user.id, keyword, 0, JSON.parse(criteria), sort, branch, limit, offset)
      .then((response) => {
        if (gen !== fetchGenRef.current) return;
        console.log("All PO Response: ", response.data);
        if (response.status == 200) {
          let temp = [...previousOrderArray, ...response.data.orders];
          setOrderArray(temp);
          setLoadMoreButtonShown(temp.length < response.data.totalCount);

          // Scroll restore is single-shot now: the id is either in this
          // response or the saved entry is stale. PoTable does the scroll.
          if (restoreRef.current) {
            const found = temp.some((order) => order.id === restoreRef.current.id);
            restoreRef.current = null;
            if (!found) {
              sessionStorage.removeItem(PO_SCROLL_STORAGE_KEY);
            }
            setRestoring(false);
          }
        }
      })
      .catch((error) => {
        console.log("error: ", error);
        setRestoring(false);
        handleError(error);
      });
  };
  const handleLoadMore = () => {
    getAllPurchaseOrder(orderArray);
  };

  // const savePO = (data) => {
  //   setIsCreateOpen(false);
  //   WOService.createWorkOrder(data)
  //     .then((response) => {
  //       console.log("response: ", response);
  //       if (response.status == 201) {
  //         toast("Work order created successfully");
  //         getAllPurchaseOrder();
  //       } else {
  //         toast("something went wrong!");
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("error: ", error);
  //       toast(error.response.data.message);
  //     });
  // };

  const downloadExcelFile = async () => {
    setIsDownloading(true);
    try {
      await POService.generateExcelFile(user.id, keyword, JSON.parse(criteria), sort, branch);
      await downloadFile(`${API_URL}/files/${user.company}/reports/${user.id}/POs_report.xlsx`, "POs_report.xlsx");
      setIsDownloading(false);
    } catch (error) {
      handleError(error);
    }
  };

  const appendBranchParam = (query, value) => {
    const currentPath = location.pathname;
    const currentSearch = location.search;

    const url = new URLSearchParams(currentSearch);
    url.set(query, value); // replaces or adds branch=0

    navigate(`${currentPath}?${url.toString()}`);
  };

  return (
    <div className="w-full h-full flex flex-col bg-backgroundColor">
      {/* <div className="h-[60px] flex items-center relative mb-12 border-b-[1px] border-borderColor">
        <span className="font-OpenSansRegular font-[700] text-[24px] ml-5 text-titleColor ">Work Orders</span>
        <div className="absolute right-7 bottom-2 flex items-center gap-8">
          <SearchBox onKewordChanged={keywordChanged} />
        </div>
      </div> */}
      {/* <div className="relative"> */}
      {/* <CreateModal onSubmitClicked={savePO} shown={isCreateOpen} onCancelClicked={() => setIsCreateOpen(false)} /> */}
      <div className="px-5 py-2 border-b border-borderColor">
        {/* {(isManagerOver() || isAccountant()) &&  */}
        <BranchBar />
        {/* } */}
      </div>
      {branch !== 0 && (
        <div className="w-full flex items-center gap-8 justify-end px-5 py-2" data-tour="po-toolbar">
          <Button onClicked={() => setFilterOpen(!filterOpen)} title="Filter" isHighlighted={filterOpen} dataTour="po-filter" />
          {filterOpen && <DownloadButton isLoading={isDownloading} onClicked={downloadExcelFile} dataTour="po-download" />}
        </div>
      )}
      {/* </div> */}
      <div className="px-5 p-5 flex-1 min-h-0 flex flex-col">
        {filterOpen && branch !== 0 && (
          <POFitlerView
            apply={(data) => {
              appendBranchParam("criteria", JSON.stringify(data));
            }}
            clear={() => localStorage.removeItem("PO_CRITERIA")}
          />
        )}
        <PoTable
          data={orderArray}
          keyword={keyword}
          branch={branch}
          loadMore={handleLoadMore}
          loadMoreButtonShown={loadMoreButtonShown}
          restoring={restoring}
          deleteSuccess={(index) => {
            let temp = _.cloneDeep(orderArray);
            temp.splice(index, 1);
            setOrderArray(temp);
          }}
          sort={(data) => setSort(data)}
        />
      </div>
    </div>
  );
}

export default PO;
